export const PASSWORD_RULES = ["passwordRule1", "passwordRule2", "passwordRule3", "passwordRule4"];

export const ACCEPTED_IMAGE_TYPES = ["image/jpeg", "image/png"];

export const ACCEPTED_FILE_TYPES = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/msword",
  "application/pdf",
  "image/*",
  "video/*",
];

export const DEFAULT_MAX_CHAR_LENGTH = 30;

export const EMAIL_MAX_CHAR_LENGTH = 100;

export const PHONE_NUMBER_MAX_CHAR_LENGTH = 30;

export const PHONE_NUMBER_ONLY_MAX_CHAR_LENGTH = 20;

export const PASSWORD_MAX_CHAR_LENGTH = 24;

export const DESCRIPTION_MAX_CHAR_LENGTH = 250;

export const DETAILS_MAX_CHAR_LENGTH = 50;

export const ADDRESS_MAX_CHAR_LENGTH = 150;

export const MAX_FILE_SIZE = 1024 * 1024 * 100; //100 MB

export const DETAIL_DESCRIPTION_MAX_CHAR_LENGTH = 500;

export const URL_MAX_LENGTH = 2000;

export const PROFILE_DESCRIPTION_MAX_CHAR_LENGTH = 10000;

export const DETAILS_DISPLAY_MAX_CHAR_LENGTH = 200;

export const SUMMARY_MAX_CHAR_LENGTH = 5000;

export const GENERAL_DATA_MAX_LENGTH = 200;

export const MESSAGE_MAX_LENGTH = 1000;

export const USER_TYPES = {
  Admin: "Admin",
  ResearchScholar: "ResearchScholar",
  Organization: "Organization",
  Funding: "Funding",
};

export const PAGE_LIMIT = 10;

export const SEARCH_KEY_MIN_LENGTH = 3;

export const SEARCH_KEY_MAX_LENGTH = 50;

export const RESEARCH_SCHOLARS_PROFILE_COMPLETION_STATUS = {
  New: 0,
  Personal: 1,
  Education: 2,
  Work: 3,
  Social: 4,
  Research: 5,
};

export const ORGANIZATION_PROFILE_COMPLETION_STATUS = {
  New: 0,
  Details: 1,
  Contacts: 2,
  Offices: 3,
  Documents: 4,
};

export const USER_STATUS = {
  New: 0,
  Draft: 1,
  PendingApproval: 2,
  Approved: 3,
  Declined: 4,
  Disabled: 5,
  Invited: 6,
  DeclineWithReason: 7,
};

export const USERS = {
  All: 0,
  Admin: 1,
  ResearchScholar: 2,
  Organization: 3,
  Funding: 4,
  ResearchInstitute: 5,
};

export const ACCEPTED_INVITE_FILE_TYPES = ["text/csv", "application/vnd.ms-excel"];

export const PREVIEW_ALLOWED_EXTENSIONS = [
  "jpg",
  "jpeg",
  "png",
  "webp",
  "gif",
  "mp4",
  "ogv",
  "mp3",
  "ppt",
  "pptx",
  "doc",
  "docx",
  "xlsx",
  "pdf",
];

export const CREATE_ORGANIZATION_INIT_STATE = {
  organizationName: "",
  organizationType: 0,
  email: "",
  contactNumber: "",
  countryCodeId: 0,
  tradingLicenseNumber: "",
};

export const PASSWORD_INITIAL_STATE = {
  password: "",
  confirmPassword: "",
};

export const INITIAL_SEARCH_PARAMS = {
  pageLimit: PAGE_LIMIT,
  pageNumber: 0,
  searchKeyword: "",
};

export const ADMIN_REQUEST_INIT_PARAMS = {
  pageNumber: 1,
  pageLimit: PAGE_LIMIT,
  profileStatusId: USER_STATUS.PendingApproval,
  userType: USERS.ResearchScholar,
  country: "",
  type: "",
  fromDate: null,
  toDate: null,
  isGlobal: "",
};

export const RESEARCH_SCHOLARS_TABLE_HEADERS = [
  "admin.created_on",
  "admin.full_name",
  "admin.research_areas",
  "global.country",
];

export const ORGANIZATIONS_TABLE_HEADERS = [
  "admin.created_on",
  "admin.name",
  "admin.type",
  "admin.email",
  "global.country",
];

export const CREATE_CHALLENGE_COMPLETION_STATUS = {
  About: 1,
  Milestones: 2,
  LearnMore: 3,
  Funding: 4,
  Artifacts: 5,
  Contacts: 6,
  Tags: 7,
};

export const ORGANIZATION_USERS_TABLE_HEADERS = [
  "admin.created_on",
  "admin.full_name",
  "global.email_address",
  "organization.actions",
];
export const CHALLENGE_TYPES = {
  Private: 1,
  Public: 2,
  All: 3,
};

export const DEFAULT_CHALLENGE_LEARN_MORE_FORMAT =
  '{"blocks":[{"key":"8dsuu","text":"Overview of current challenges","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":30,"style":"BOLD"}],"entityRanges":[]},{"key":"bufa5","text":"Briefly describe the primary challenges faced by your company in the industrial sector.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"31ul0","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"dbq53","text":"Detailed description of the challenge","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":37,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"6ovit","text":"Provide a more in-depth description of the challenge identified in the previous section. Elaborate on the factors contributing to these challenges and their impact on your company\'s operations, productivity, or profitability.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"3mocd","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"29gf1","text":"Desired enhancement","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":19,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"6qpv2","text":"Specify the desired enhancements or improvements that would address the identified challenge. Clearly state the goals and outcomes you hope to achieve through these enhancements.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"f5lf5","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"actja","text":"Resources and constraints","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":25,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"bhf4n","text":"Indicate that there are resources(financial, technological, human etc.) currently available to support finding solutions for the challenge. Identify any constraints or limitations that may affect the implementation of proposed enhancements.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"5u008","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"c1c1","text":"Success metrics","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":15,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"4ms3i","text":"Define the metrics or key performance indicators(KPIs) that will be used to measure the success of the proposed enhancements. If there are known benchmarks for each metric to gauge the effectiveness of the solutions, you may establish targets.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}';

export const DEFAULT_EDITOR_EMPTY_STATE =
  '{"blocks":[{"key":"8dsuu","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}';

export const ADDITIONAL_INFO_PLACEHOLDER =
  "Provide any additional information, reports, or documents that can help the researchers better understand your company's challenges and requirements. Include any relevant insights or experiences related to previous attempts to address these challenges. Remember the more detailed and specific information provided as possible, the more comprehensive the information provided, the better researchers will understand the challenges and propose tailored solutions.";

export const CHALLENGE_STATUS = {
  New: 0,
  Draft: 1,
  Open: 2,
  Live: 3,
  Close: 4,
  All: 5,
  Disable: 6,
  Pending: 7,
  Decline: 8,
};

export const HOME_MENU_IDS = {
  AboutUs: 1,
  JoinUs: 2,
  DataInsights: 3,
  Challenges: 4,
  HowItWorks: 5,
  CaseStudies: 6,
  NewsAndEvents: 7,
  ContactUs: 8,
};

export const RESEARCH_SCHOLAR_CHALLENGE_INIT_PARAMS = {
  pageNumber: 1,
  pageLimit: PAGE_LIMIT,
  status: CHALLENGE_STATUS.All,
  type: CHALLENGE_TYPES.Public,
  researchArea: [],
  isOwned: false,
  isExplore: false,
  isGlobal: "",
};

export const CHALLENGE_USERS_TABLE_HEADERS = [
  "admin.created_on",
  "admin.full_name",
  "research_institute.research_institute",
  "admin.research_areas",
  "global.country",
];

export const CHALLENGE_USER_STATUS = {
  PendingApproval: 1,
  Approved: 2,
  FundingOrganization: 3,
  PendingResearchInstituteApproval: 5,
};

export const CHALLENGE_USERS_INITIAL_PARAMS = {
  challengeId: 0,
  pageNumber: 1,
  pageLimit: PAGE_LIMIT,
  statusId: CHALLENGE_USER_STATUS.PendingApproval,
  researchInstitute: "",
  fromDate: null,
  toDate: null,
};

export const RESEARCH_SCHOLAR_CHALLENGE_REQUEST_STATUS = {
  PendingApproval: 1,
  Approved: 2,
  Declined: 3,
  Remove: 4,
  Withdraw: 6,
};

export const EMAIL_VALIDATION_PATTERN =
  /^([\w-.+#$%&*()=?]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;

export const PASSWORD_VALIDATION_PATTERN = /^(?=.*[0-9])(?=.*[A-Z])(?=.*[\W_]).{8,24}$/;

export const INVALID_CHARACTER_VALIDATION_PATTERN = /^[()-\d\s]+$/;

export const ORGANIZATION_CHALLENGE_INIT_PARAMS = {
  pageNumber: 1,
  pageLimit: PAGE_LIMIT,
  status: CHALLENGE_STATUS.All,
  type: CHALLENGE_TYPES.All,
  researchArea: [],
  isOwned: false,
  isExplore: false,
  isGlobal: "",
};

export const ORGANIZATION_TYPES = {
  Private: 1,
  Public: 2,
  StartUp: 3,
  PublicPrivate: 4,
  NGO: 5,
  NPO: 6,
};

export const FUNDING_ORGANIZATION_INIT_STATE = {
  organizationName: "",
  organizationType: 0,
  email: "",
  contactNumber: "",
  countryCodeId: 0,
};

export const CONTACTS_INFO_INITIAL_STATE = {
  id: 0,
  fullName: "",
  designation: "",
  email: "",
  countryCodeId: -1,
  contactNumber: "",
  isPrimary: true,
};

export const OFFICE_DETAILS_INITIAL_STATE = {
  id: 0,
  name: "",
  address: "",
};

export const LATEST_CHALLENGE_PAGE_LIMIT = 8;

export const ADMIN_CHALLENGE_INIT_PARAM = {
  pageNumber: 1,
  pageLimit: LATEST_CHALLENGE_PAGE_LIMIT,
  status: CHALLENGE_STATUS.All,
  type: CHALLENGE_TYPES.All,
  researchArea: [],
  isOwned: false,
  isExplore: false,
  isGlobal: "",
};

export const RESEARCH_SCHOLAR_INVITES_PARAM = {
  pageNumber: 1,
  pageLimit: LATEST_CHALLENGE_PAGE_LIMIT,
};

export const LEARN_MORE_MAX_CHAR_LENGTH = 400;

export const RESEARCH_PROJECT_INITIAL_STATE: ResearchProject = {
  researchProjectId: null,
  researchTitle: "",
  researchBrief: "",
  isInProgress: false,
  startDate: "",
  endDate: "",
  documents: [],
  projectUrl: "",
  publicUrl: "",
  areaOfExpertise: [],
  tags: [],
};

export const CHALLENGE_FUNDING_TABLE_HEADERS = [
  "admin.created_on",
  "admin.full_name",
  "global.country",
  "organization.contact",
  "admin.email",
];

export const CHALLENGE_SUMMARY_TYPES = {
  pendingApprovals: 1,
  acceptedScholars: 2,
  fundingOrganizations: 3,
};

export const FUNDING_INTEREST_TAB = {
  message: 0,
  about: 1,
};

export const RESEARCH_INSTITUTE_INIT_STATE = {
  instituteName: "",
  instituteTypeId: 0,
  email: "",
  status: 0,
  countryCodeId: 0,
  contactNumber: "",
};

export const RESEARCH_INSTITUTE_STATUS = {
  startUp: 1,
  others: 2,
};

export const INVITE_HISTORY_TABLE_HEADERS = [
  "organization.invited_on",
  "admin.full_name",
  "admin.type",
  "global.email_address",
  "research_institute.status",
];
export const EXPLORE_CHALLENGE_INIT_PARAMS = {
  pageNumber: 1,
  pageLimit: PAGE_LIMIT,
  status: CHALLENGE_STATUS.All,
  type: CHALLENGE_TYPES.All,
  researchArea: [],
  isOwned: false,
  isExplore: true,
  isGlobal: "",
};

export const ALL_USERS_TABLE_HEADERS = [
  "admin.created_on",
  "global.user_type",
  "admin.full_name",
  "global.country",
];

export const CHALLENGE_TRACK_INVITE_PARAMS = {
  challengeId: 0,
  pageNumber: 1,
  pageLimit: PAGE_LIMIT,
};

export const CALENDER_START_DATE = "01/01/2023";

export const GLOBAL_SEARCH_TYPES = {
  users: "users",
  challenge: "challenge",
};

export const FILTER_INIT_STATE = {
  createdOn: false,
  type: false,
  country: false,
};

export const FILTER_ALL_USERS_INIT_STATE = {
  createdOn: false,
  country: false,
};

export const EXPLORE_CHALLENGE_PATH_PATTERN = /\d+\/explore/;

export const EXPLORE_COLLABORATION_PATH_PATTERN = /collaborations\/explore\/\d+/;

export const VIEW_REQUEST_RESEARCH_SCHOLAR_PATH_PATTERN =
  /requests\/\d+\/research-scholar\/([\w-]+)/;

export const EXPLORE_CHALLENGE_VIEW_SCHOLAR_PATH_PATTERN = /\d+\/explore\/research-scholar/;

export const CREATE_CHALLENGE_PATH_PATTERN = /create\/\d+/;

export const COLLABORATION_PATH_PATTERN = /requests\/collaborations\/\d+/;

export const COLLABORATION_SCHOLAR_PREVIEW_PATH_PATTERN =
  /requests\/collaborations\/\d+\/research-scholar\/([\w-]+)/;

export const SCHOLAR_DETAILS_PATH_PATTERN = /(\d+)\/research-scholar\/([\w-]+)/;

export const ADMIN_PERMISSION_LIST = {
  Viewopenchallenges: true,
  Viewlivechallenges: true,
  Viewclosedchallenges: true,
  Participationrequest: true,
  Viewinvites: true,
  Manageinvites: true,
  Viewpost: true,
  Viewprivatereplies: true,
  Createpost: true,
  Createchallenge: true,
  Viewdraftchallenges: true,
  Managechallengestatus: true,
  Uploadcasestudytochallenge: true,
  Invitescholars: true,
  Viewchallengerequests: true,
  Viewapprovedscholars: true,
  ViewfundingorganizationInterests: true,
  ApproveDeclinescholars: true,
  Removescholars: true,
  Explorechallenges: true,
  Showinterest: true,
};

export const IMAGE_MAX_FILE_SIZE = 1024 * 1024 * 25; //25 MB

export const HIGHER_EDUCATION_MAX_LIMIT = 6;

export const WORK_EXPERIENCE_MAX_LIMIT = 6;

export const PATHS = [
  "/admin/users/research-scholar",
  "/admin/users/organization",
  "/admin/users/funding-organization",
  "/admin/users/research-institute",
  "/admin/challenges",
  "/admin/users",
  "/admin/search-results",
  "/research-scholar/challenges",
  "/research-scholar/home",
  "/research-scholar/search-results",
  "/organization/challenges",
  "/organization/challenges/explore",
  "/organization/search-results",
  "/funding-organization/home",
  "/funding-organization/challenges",
  "/funding-organization/search-results",
  "/research-institute/challenges",
  "/research-institute/search-results",
  "/research-institute/requests",
  "/research-institute/researchers",
  "/admin/events",
  "/organization/events",
  "/research-scholar/events",
  "/research-institute/events",
  "/funding-organization/events",
  "/admin/collaborations",
  "/organization/collaborations",
  "/research-scholar/collaborations",
  "/research-institute/collaborations",
  "/research-institute/collaborations/explore",
];
export const SUB_DOMAIN_MAX_LENGTH = 255;

export const PARTICIPATION_REQUESTS = {
  PendingApproval: 5,
  Nominated: 1,
};

export const PARTICIPATION_REQUESTS_INIT_PARAMS = {
  pageNumber: 1,
  pageLimit: PAGE_LIMIT,
  statusId: PARTICIPATION_REQUESTS.PendingApproval,
  researchInstitute: "",
  fromDate: null,
  toDate: null,
};

export const NOMINATED_USERS_TABLE_HEADER = [
  "admin.created_on",
  "admin.full_name",
  "admin.research_areas",
  "global.country",
  "global.status",
];

export const INVITED_RESEARCH_INSTITUTE_TABLE_HEADERS = [
  "admin.created_on",
  "admin.name",
  "global.status",
  "admin.type",
  "admin.email",
  "organization.contact",
];

export const PERMISSION_LIST_TABS = {
  researchInstitute: 2,
};

export const EVENT_CREATION_COMPLETION_STATUS = {
  About: 1,
  LearnMore: 2,
};

export const GLOBAL_PORTAL_FILTERS = {
  Both: 1,
  National: 2,
  Global: 3,
};

export const EVENT_STATUS = {
  Draft: 0,
  All: 1,
  Upcoming: 2,
  Live: 3,
  Closed: 4,
};

export const EVENT_COMPLETION_STATUS = {
  About: 1,
  LearnMore: 2,
  Publish: 3,
};

export const ADMIN_EVENT_LIST_INIT_PARAMS = {
  pageNumber: 1,
  pageLimit: PAGE_LIMIT,
  status: EVENT_STATUS.All,
  targetIndustry: [],
};

export const COLLABORATION_DASHBOARD_INIT_PARAMS = {
  pageNumber: 1,
  pageLimit: PAGE_LIMIT,
  status: CHALLENGE_STATUS.All,
  type: CHALLENGE_TYPES.All,
  researchArea: [],
  isOwned: false,
  isExplore: false,
  isRequest: false,
};

export const COLLABORATION_LIST_INIT_PARAMS = {
  pageNumber: 1,
  pageLimit: PAGE_LIMIT,
  status: CHALLENGE_STATUS.All,
  type: CHALLENGE_TYPES.All,
  researchArea: [],
  isOwned: false,
  isExplore: false,
};

export const TOASTER_DURATION = 1700;

export const EXPLORE_COLLABORATIONS_INIT_PARAMS = {
  pageNumber: 1,
  pageLimit: PAGE_LIMIT,
  status: CHALLENGE_STATUS.All,
  type: CHALLENGE_TYPES.All,
  researchArea: [],
  isOwned: false,
  isExplore: true,
};
export const COLLABORATION_USER_STATUS = {
  InstitutePending: 1,
  Nominated: 2,
  Pending: 3,
  Approved: 4,
  Declined: 5,
  Removed: 6,
  Withdraw: 7,
};
export const COLLABORATION_USERS_INITIAL_PARAMS = {
  collaborationId: 0,
  pageNumber: 1,
  pageLimit: PAGE_LIMIT,
  statusId: COLLABORATION_USER_STATUS.Pending,
  researchInstitute: "",
  fromDate: null,
  toDate: null,
  isRequest: false,
};

export const DEFAULT_COLLABORATION_LEARN_MORE_FORMAT =
  '{"blocks":[{"key":"8dsuu","text":"Overview of the collaboration","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":30,"style":"BOLD"}],"entityRanges":[]},{"key":"bufa5","text":"Briefly describe the area and the aspects of collaboration (abstract).","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"31ul0","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"dbq53","text":"Detailed description of the collaboration","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":41,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"6ovit","text":"Provide a more in-depth description of the challenge and aspect of collaboration identified in the previous section.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"3mocd","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"29gf1","text":"Resources and constraints","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":25,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"6qpv2","text":"Indicate that there are resources available or needed for this collaboration.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"f5lf5","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"actja","text":"Desired collaboration outcomes/targets","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":38,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"bhf4n","text":"State the goals and the outcomes you hope to achieve via the collaboration.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}';

export const FORUM_TYPES = {
  collaborations: 2,
  challenges: 1,
};

export const COLLABORATION_TRACK_INVITE_PARAMS = {
  collaborationId: 0,
  pageNumber: 1,
  pageLimit: PAGE_LIMIT,
};

export const ADVISOR_TOGGLE_BUTTON = {
  enabled: 1,
  disabled: 0,
};

export const RESEARCH_INSTITUTE_TABLE_HEADERS = [
  "admin.created_on",
  "admin.name",
  "global.status",
  "admin.type",
  "admin.email",
  "global.country",
];

export const VIEW_MORE_INIT_STATE: ViewMore = {
  overview: false,
  description: false,
  resources: false,
  targets: false,
  summary: false,
  additionalInfo: false,
};

export const CHALLENGE_VIEW_MORE_INIT_STATE: ChallengeViewMore = {
  desiredEnhancements: false,
  detailedDescriptionOftheChallenges: false,
  overviewOfCurrentChallenges: false,
  resourcesAndConstraints: false,
  successMetrics: false,
  additionalInfo: false,
};

export const TRIGGER_EMAIL_NOTIFICATION_OPTIONS: Array<DropdownButtonItem> = [
  { type: "allResearchers", label: "admin.notify_all_researchers" },
  { type: "byTag", label: "admin.notify_by_tags" },
];
